import { checkInDateRange } from './fields/checkInDateRange';
import { serializeQuery, type QueryObject } from './serializeQuery';
import type { SearchCriteria, PartialSearchCriteria } from '../model/types';
import { fromCity } from './fields/fromCity';
import { hotels } from './fields/hotels';
import { nightRange } from './fields/nightRange';
import { resorts } from './fields/resorts';
import { toCountry } from './fields/toCountry';
import { touristGroup } from './fields/touristGroup';

export function getToursUrl(criteria: SearchCriteria | PartialSearchCriteria, otherCriteria: QueryObject = {}): string {
  return serializeQuery({
    ...fromCity(criteria),
    ...toCountry(criteria),
    ...resorts(criteria),
    ...checkInDateRange(criteria),
    ...nightRange(criteria),
    ...touristGroup(criteria),
    ...hotels(criteria),
    ...otherCriteria,
  });
}
